export default __webpack_public_path__ + "static/media/white_agreement.9f556c17.svg";